import { enqueueSnackbar, UploadMultipleFiles } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';

import {
	RunNbrRelationsOptimizationRequest,
	GetNbrRelationsOptimizationExportRequest,
	GetNbrRelationsOptimizationTableRequest
} from '../requests/NbrRelationsOptimizationRequests.js';

export const GET_NBRRELATIONS_OPTIMIZATION_TABLE = 'GET_NBRRELATIONS_OPTIMIZATION_TABLE';

const onGetNbrRelationsOptimizationTable = (value) => ({
	type: GET_NBRRELATIONS_OPTIMIZATION_TABLE,
	nbrRelationsOptimizationTableData: value
});

export const GetNbrRelationsOptimizationTable = () => async (dispatch) => {
	await GetNbrRelationsOptimizationTableRequest().then(response => {
		dispatch(onGetNbrRelationsOptimizationTable(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetNbrRelationsOptimizationExport = (nbrRelationsOptimizationId) => async (dispatch) => {
	await GetNbrRelationsOptimizationExportRequest(nbrRelationsOptimizationId).then(response => {
		if (response.data.includes(':\\')) {
			dispatch(DownloadFile(response.data));
		} else {
			dispatch(enqueueSnackbar({ message: response.data, options: { variant: 'success' } }));
		}
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const RunNbrRelationsOptimization = (userId, filesPath) => async (dispatch) => {
	await RunNbrRelationsOptimizationRequest(userId, filesPath).then(response => {
		if (response.data.includes(':\\')) {
			dispatch(DownloadFile(response.data));
		} else {
			dispatch(enqueueSnackbar({ message: response.data, options: { variant: 'success' } }));
		}
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const NbrRelationsOptimizationUploadRun = (userId, files) => async (dispatch) => {
	await UploadMultipleFiles(files).then(response => {
		dispatch(RunNbrRelationsOptimization(userId, response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
